export default __webpack_public_path__ + "static/media/meta.3ca93659.svg";